<script setup lang="ts">
import EditorDetail from '@/components/modal/worksheet/EditorDetail.vue';

interface Props {
  tourWorkSheet: any;
}
defineProps<Props>();

const emits = defineEmits<{ handleSaveDataEditTerm: [value: any] }>();

const handleSaveDataEditTerm = (event: string, field: string) => {
  const data = {
    field: field,
    value: event
  };
  emits('handleSaveDataEditTerm', data);
};
</script>

<template>
  <div>
    <div class="intro">
      <h4 class="font-bold text-lg">{{ $t('common.intro') }}</h4>
      <EditorDetail :dataEdited="tourWorkSheet.intro" :permission="true" @handleSaveDataEdit="handleSaveDataEditTerm($event, 'intro')" />
    </div>
    <div class="term-conditions mt-4">
      <h4 class="font-bold text-lg">{{ $t('menu.term_and_condition') }}</h4>
      <EditorDetail :dataEdited="tourWorkSheet.termConditions" :permission="true" @handleSaveDataEdit="handleSaveDataEditTerm($event, 'termConditions')" />
    </div>
  </div>
</template>
